import { createV3Queries } from "@query/utils/createV3Queries";
import { featureFlagsApi } from "@api";

export const queriesFeatureFlags = createV3Queries(
  "featureFlagsApi",
  featureFlagsApi
);
